export default __webpack_public_path__ + "static/media/FN2025-opengraph.c23cd65b.png";